'use strict';

var getConfig = function getConfig(name, config) {
  return config.find(function (item) {
    return item.name === name;
  });
};
var hasPages = function hasPages(pages) {
  return pages && pages.length > 0;
};
var setLink = function setLink(link, slug) {
  return link !== null ? link : slug;
};
var cleanPages = function cleanPages(pages, parentSlug) {
  return pages.map(function (_ref) {
    var name = _ref.name,
      link = _ref.link,
      slug = _ref.slug,
      lg_pages = _ref.lg_pages;
    var newSubPages = hasPages(lg_pages) ? cleanPages(lg_pages, "".concat(parentSlug, "/").concat(slug)) : [];
    return {
      name: name,
      link: setLink(link, "".concat(parentSlug, "/").concat(slug)),
      lg_pages: newSubPages
    };
  });
};
var cleanLCSubPages = function cleanLCSubPages(pages) {
  return pages.map(function (_ref2) {
    var name = _ref2.name,
      link = _ref2.link;
    return {
      name: name,
      link: link
    };
  });
};
var cleanLCPages = function cleanLCPages(pages) {
  return pages.map(function (_ref3) {
    var name = _ref3.name,
      link = _ref3.link,
      lc_pages = _ref3.lc_pages;
    var newSubPages = hasPages(lc_pages) ? cleanLCSubPages(lc_pages) : [];
    return {
      name: name,
      link: link,
      lg_pages: newSubPages
    };
  });
};
var cleanMenuData = function cleanMenuData(dataLG, dataLC, config) {
  var newData = dataLG.map(function (_ref4) {
    var name = _ref4.name,
      slug = _ref4.slug,
      lg_pages = _ref4.lg_pages;
    var setConfig = getConfig(slug, config);
    var rootSlug = setConfig.root;
    var useLC = setConfig.lc && dataLC.find(function (item) {
      return item.name === name.toUpperCase();
    });
    var lgPages = !setConfig.lc && hasPages(lg_pages) ? cleanPages(lg_pages, rootSlug) : [];
    var lcPages = setConfig.lc && hasPages(useLC.lc_page_groups) ? cleanLCPages(useLC.lc_page_groups) : [];
    return {
      name: name,
      link: rootSlug,
      lg_pages: setConfig.lc ? lcPages : lgPages
    };
  });
  return newData;
};
var cleanUtilMenuData = function cleanUtilMenuData(dataUtil, config) {
  var newUtil = dataUtil.map(function (_ref5) {
    var name = _ref5.name,
      lg_utility_item = _ref5.lg_utility_item;
    var newUtilItem = lg_utility_item.map(function (_ref6) {
      var name = _ref6.name,
        link = _ref6.link;
      var setConfig = getConfig(name, config);
      return {
        name: name,
        link: setConfig ? setConfig.root : link
      };
    });
    return {
      name: name,
      lg_utility_item: newUtilItem
    };
  });
  return newUtil;
};

exports.cleanMenuData = cleanMenuData;
exports.cleanUtilMenuData = cleanUtilMenuData;
exports.getConfig = getConfig;
//# sourceMappingURL=nav.js.map
